export default __webpack_public_path__ + "static/media/not_found_sm.341a360a.jpg";